import { useSearchParams } from '@occc-app/hooks/useSearchParams';

import { SiteManagementTab } from './types';

const LOCATIONS_PREFIX = 'all';

export const LOCATIONS_BEFORE_PARAM = `${LOCATIONS_PREFIX}-before`;
export const LOCATIONS_AFTER_PARAM = `${LOCATIONS_PREFIX}-after`;
export const LOCATIONS_SORT_FIELD_PARAM = `${LOCATIONS_PREFIX}-sort-field`;
export const LOCATIONS_SORT_DIRECTION_PARAM = `${LOCATIONS_PREFIX}-sort-direction`;

export const LOCATIONS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATIONS_PREFIX}-search`,
  afterParamName: LOCATIONS_AFTER_PARAM,
  beforeParamName: LOCATIONS_BEFORE_PARAM,
};

export const SITE_MANAGEMENT_TAB_PARAM = 'tab';
export const DEFAULT_SITE_MANAGEMENT_TAB: SiteManagementTab = 'locations';
export const SITE_MANAGEMENT_TABS: SiteManagementTab[] = ['locations', 'groups'];
